module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "pro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "aria-label": "13",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Jason stood in a small enclosure between two doors, leaned forward, and touched the tip of his finger to the pad mounted on the door in front of him. The door said, “Retinal scan and digital chip match. Colonel Jason Jenner,” opened to a long flight of metal steps, and locked behind him. His boots rang on each step.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("At the bottom was a small windowless space with three doors. Two were unmarked, one of heavy wood and one of alien metal. The third, fitted with a decontamination chamber and the soft whoosh of negative pressure, bore a sign:")]), _vm._v(" "), _c('p', {
    staticClass: "Illustration-holder-ill"
  }, [_c('img', {
    staticClass: "img20",
    attrs: {
      "alt": "",
      "src": "images/pg1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Inscription-ins1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("BIOHAZARDOUS MATERIAL")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Inscription-ins"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("DANGER!")])]), _vm._v(" "), _c('p', {
    staticClass: "Extract-Inscription-ins"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("AUTHORIZED PERSONNEL ONLY")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-Space-Before--tx"
  }, [_vm._v("Jason keyed his way into the unmarked wooden door and closed it. In a tiny, sound-baffled space, a soldier jumped up from a stool and saluted.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jason said, “Any trouble, Corporal?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, sir. Sleeping, breathing, saying nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "14",
      "id": "pg_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The guard room led to two cells, both with a single barred plastic window. Jason opened one of the cell doors and entered. The cell stank. The prisoner, naked, lay on his side on the bare floor in a stain of his own dried piss. His wrists were manacled with a short chain; another secured one ankle to the wall. Both had bloodied strips of skin. He opened his eyes to stare at Jason, who had to restrain himself from kicking him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("This was one of the men who had broken the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Dr. Anderson, are you ready to talk to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The prisoner said nothing. He had water within reach but had not eaten for three days. Only a few of the people in the base above, none of them civilians, even knew he was here. It had taken Army Intelligence—such as it was, since the Collapse—eight years to find this man. He was the last Gaiist they would ever find.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“If you don’t talk to me…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jason didn’t have to finish the sentence, which was good. He was weak enough—that’s how he thought of it—to shrink from torture, even though this man deserved anything that Jason’s men could do to him. But the sentence was such a clich"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(", even if the situation was not. Never before in the world had there been a situation like this. But always somewhere in Jason’s mind, inescapable as the dull throb of headache, was what Colin would think.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The prisoner finally spoke. “We saved the Earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Anger surged so strong that for a moment Jason’s vision filled with red haze. He regained control.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Are you going to tell us their plans? New America is your enemy as much as ours.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Anderson went on gazing at him from pale blue eyes. For a moment Jason thought that Anderson was actually going to give up. But all he did was repeat, “We saved the Earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Disgusted, Jason turned to leave. To Anderson he said, “You have until tomorrow morning to talk voluntarily.” To the sergeant, “No change in treatment.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "15",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Yes, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We saved the Earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nothing could be less true.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Or more so.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 78
// module chunks = 0